var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Wrapper, Header, Icon } from '@mademine/components';
import { I18n } from '@mademine/utils';
import { useData } from '../hooks/useData';
import { ReactComponent as LeftIcon } from '../assets/icon-arrow-bold-left.svg';
import { ReactComponent as PictureIcon } from '../assets/icon-line-picture.svg';
import ColorDrawer from '../components/color/Drawer';
import ColorButton from '../components/color/Button';
import AvatarPlaceholder from '../components/AvatarPlaceholder';
import ChooseOption from '../components/ChooseOption';
import EditDrawer from '../components/EditDrawer';
import { TaskStatus } from './index';
import classNames from 'classnames';
import { thumbnailOss } from '../utils';
var HeaderContent = function (_a) {
    var colorVisiable = _a.colorVisiable, setColorVisiable = _a.setColorVisiable, onClickAvatar = _a.onClickAvatar;
    var _b = useData(), peopleNumber = _b.peopleNumber, images = _b.images, setEditVisible = _b.setEditVisible, setPeopleIndex = _b.setPeopleIndex;
    var handleClickAvatar = function (index) {
        setEditVisible(true);
        setPeopleIndex(index);
    };
    return (_jsxs("div", { className: "_sz-relative _sz-h-full", children: [_jsx("div", { className: "_sz-mr-[34px] _sz-flex _sz-h-16 _sz-items-center _sz-justify-center", children: !colorVisiable &&
                    images.map(function (image, index) {
                        var _a;
                        return image[0].isDefault ? (_jsx(AvatarPlaceholder, { className: classNames('_sz-cursor-pointer', (_a = {},
                                _a['_sz-mr-3'] = index !== peopleNumber - 1,
                                _a)), onClick: function () { return onClickAvatar(index); } }, index)) : (_jsx("div", { className: "_sz-h-14 _sz-w-14 _sz-cursor-pointer _sz-rounded-full _sz-bg-[#F1F1F1] _sz-p-[5px] ".concat(index === peopleNumber - 1 ? '' : '_sz-mr-3'), onClick: function () { return handleClickAvatar(index); }, children: _jsx("img", { className: "_sz-h-full _sz-w-full _sz-object-contain", src: image[0].image, alt: "user profile" }) }, index));
                    }) }), _jsx(ColorButton, { className: "_sz-absolute _sz-right-0 _sz-top-1/2 _sz-mr-0.5\t-_sz-translate-y-1/2 ", colorVisiable: colorVisiable, setColorVisiable: setColorVisiable })] }));
};
var Choose = function (_a, ref) {
    var productType = _a.productType, sortOption = _a.sortOption, userImage = _a.userImage, selectedOption = _a.selectedOption, setZuploaderVisible = _a.setZuploaderVisible, setSelectedOption = _a.setSelectedOption, setTaskStatus = _a.setTaskStatus, setPassPreviewEdit = _a.setPassPreviewEdit, onClose = _a.onClose;
    var setViualizerPreviewVisible = useData().setViualizerPreviewVisible;
    var selectedName = I18n.format('modules.mini.me.all') || '';
    var sortNames = Object.keys(sortOption);
    if (sortNames.length === 2) {
        selectedName = sortNames.filter(function (item) { return item != selectedName; })[0];
    }
    var selectedColor = useData().selectedColor;
    var _b = useState(false), colorVisiable = _b[0], setColorVisiable = _b[1];
    var _c = useState(selectedName), selectedSort = _c[0], setSelectedSort = _c[1];
    var _d = useState(productType === 'balloon'
        ? sortOption[selectedSort].slice(0, 6)
        : sortOption[selectedSort].slice(0, 10)), optionList = _d[0], setOptionList = _d[1];
    var _e = useState(0), count = _e[0], setCount = _e[1];
    var _f = useState(0), bottomImageWidth = _f[0], setBottomImageWidth = _f[1];
    var _g = useState(false), editDrawer = _g[0], setEditDrawer = _g[1];
    var _chooseContent = useRef(null);
    var _optionLayout = useRef(null);
    useImperativeHandle(ref, function () { return ({
        update: function () {
            setCount(count + 1);
        }
    }); });
    var handleSelectOption = function (option) {
        var _a;
        (_a = _chooseContent.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
        setSelectedSort(option);
        setOptionList(productType === 'balloon'
            ? sortOption[option].slice(0, 6)
            : sortOption[option].slice(0, 10));
    };
    var handleChooseScroll = function (event) {
        var _a = event.currentTarget, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        if ((scrollHeight - clientHeight) * 0.8 <= scrollTop) {
            var currentOption = sortOption[selectedSort];
            var index = optionList.length;
            var nextIndex = index + 10;
            if (nextIndex > currentOption.length) {
                nextIndex = currentOption.length;
            }
            setOptionList(__spreadArray(__spreadArray([], optionList, true), currentOption.slice(index, nextIndex), true));
        }
    };
    var handleOptionClick = function (option) {
        if (!userImage.some(function (item) { return item.isDefault; })) {
            if (productType === 'balloon') {
                setViualizerPreviewVisible(true);
            }
            else {
                setEditDrawer(true);
            }
            var needEditText = isneedEditText(option.origin.text);
            setSelectedOption(option);
            if (needEditText)
                handleEdit(false);
        }
        else
            setZuploaderVisible(true);
    };
    var handleClickAvatar = function () {
        setZuploaderVisible(true);
    };
    var getFisrtImg = function (images) {
        var selectColor = selectedColor.map(function (item) { return item.name; }).join('-');
        var result = images[0].origin.images.find(function (item) {
            return item.color.includes(selectColor);
        });
        var type = images[0].origin.type;
        return {
            url: (result === null || result === void 0 ? void 0 : result.url) || '',
            type: type || 'normal'
        };
    };
    var handleEdit = function (isPassPreviewEdit) {
        setEditDrawer(false);
        setTaskStatus(TaskStatus.Preview);
        setPassPreviewEdit(isPassPreviewEdit);
    };
    var isneedEditText = function (textList) {
        if (!textList || textList.length === 0)
            return false;
        return textList.some(function (item) { return !item.text; });
    };
    var handleColorSelect = function (isSameColor) {
        setColorVisiable(false);
        if (isSameColor)
            return;
        var allName = I18n.format('modules.mini.me.all') || '';
        sortOption[allName].forEach(function (item) {
            var isSameBodyUrl = item.origin.images.every(function (value) { return value.url === item.origin.images[0].url; });
            if (!isSameBodyUrl) {
                item.loading.body = true;
            }
            if (item.origin.annex) {
                var annexs = item.origin.annex;
                annexs.forEach(function (annex) {
                    var isSameAnnexUrl = annex.images.every(function (value) { return value.url === annex.images[0].url; });
                    if (!isSameAnnexUrl) {
                        item.loading["annex-".concat(annex.id)] = true;
                    }
                });
            }
        });
        setOptionList(sortOption[selectedSort].slice(0, sortOption[selectedSort].length));
    };
    useEffect(function () {
        var _a;
        if (_chooseContent.current) {
            if (_optionLayout.current) {
                setBottomImageWidth(Math.floor(((_a = _optionLayout.current.firstElementChild) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0));
            }
        }
    }, []);
    return (_jsxs(Wrapper, { position: "absolute", className: "_sz-inset-0 _sz-flex _sz-flex-col _sz-bg-white", children: [_jsx(Header, { className: "!_sz-z-[5] !_sz-h-16 _sz-shrink-0 _sz-bg-white", renderCloseContent: colorVisiable ? (_jsx("div", {})) : (_jsx(Icon, { size: 24, color: "#000", children: _jsx(LeftIcon, {}) })), renderContent: _jsx(HeaderContent, { colorVisiable: colorVisiable, setColorVisiable: setColorVisiable, onClickAvatar: handleClickAvatar }), onClose: onClose }), colorVisiable && (_jsx(ColorDrawer, { className: "!_sz-top-16", onSelectConfirm: handleColorSelect })), _jsxs("div", { className: "_sz-flex _sz-flex-1 _sz-overflow-hidden", children: [sortNames.length > 2 && (_jsx("div", { className: "_sz-w-[92px] _sz-overflow-auto _sz-bg-white\t", children: _jsx("div", { className: "_sz-px-2.5 _sz-pt-3 _sz-pb-2", children: Object.keys(sortOption).map(function (item, index) {
                                return (_jsxs("div", { className: "_sz-mb-1 _sz-cursor-pointer _sz-rounded-lg _sz-px-[5px] _sz-pt-2 _sz-pb-1", style: {
                                        backgroundColor: selectedSort === item
                                            ? 'var(--sunzi-theme-color-006)'
                                            : 'white'
                                    }, onClick: function () { return handleSelectOption(item); }, children: [_jsx("div", { className: classNames('_sz-mx-[5px] _sz-h-13 _sz-bg-bottom _sz-ml-0 _sz-w-full _sz-bg-cover', {
                                                ' _sz-bg-no-repeat': getFisrtImg(sortOption[item]).type === 'balloon'
                                            }), style: {
                                                backgroundImage: "url(".concat(thumbnailOss(getFisrtImg(sortOption[item]).url, 100), ")"),
                                                backgroundSize: "".concat(getFisrtImg(sortOption[item]).type === 'balloon'
                                                    ? 'contain'
                                                    : '')
                                            } }), _jsx("div", { className: "_sz-w-full _sz-break-words _sz-text-center _sz-text-xs _sz-font-medium", children: item.split('-')[0] }), productType !== 'balloon' && (_jsx("div", { className: "_sz-w-full _sz-break-words\t_sz-text-center _sz-text-xs", children: sortOption[item].length }))] }, index));
                            }) }) })), userImage[0] && (_jsxs("div", { className: "_sz-flex-1", children: [userImage.some(function (item) { return item.isDefault; }) && (_jsx("div", { className: "_sz-w-full _sz-bg-white", children: _jsxs("div", { className: "_sz-flex _sz-h-full _sz-w-full _sz-items-center _sz-justify-center _sz-bg-[rgba(255,73,51,0.06)] _sz-p-3 _sz-text-[#FF543E]", children: [_jsx(Icon, { size: 20, color: "#FF543E", className: "_sz-mr-2", children: _jsx(PictureIcon, {}) }), _jsx("span", { className: "_sz-text-sm\t_sz-font-medium", children: I18n.format('upload.tip') })] }) })), _jsx("div", { className: "_sz-h-full _sz-w-full _sz-overflow-auto _sz-bg-[#F1F1F1] _sz-p-3", ref: _chooseContent, onScroll: handleChooseScroll, children: _jsx("div", { ref: _optionLayout, className: "_sz-grid _sz-grid-cols-2 _sz-gap-x-2 _sz-mb-[14px] ".concat(userImage.every(function (item) { return !item.isDefault; })
                                        ? '_sz-gap-y-[25px]'
                                        : '_sz-gap-y-3'), children: optionList.map(function (item, index) { return (_jsx(ChooseOption, { count: count, option: item, bottomImageWidth: bottomImageWidth, avatars: userImage, selectedColor: selectedColor, handleOptionClick: handleOptionClick }, item.id)); }) }) })] }))] }), editDrawer && selectedOption && (_jsx(EditDrawer, { productType: productType, option: selectedOption, avatars: userImage, selectedColor: selectedColor, onClose: function () { return setEditDrawer(false); }, onEnterEdit: function () { return handleEdit(false); }, onPassEdit: function () { return handleEdit(true); } }))] }));
};
export default forwardRef(Choose);
